export const cUserStates = {
    creado: 0,
    habilitado: 1,
    deshabilitado: 2,
    bloqueado: 3
}

export const lstUserStates = [
    {
        tipoVentaId: cUserStates.habilitado,
        nombre: "Habilitado"
    },
    {
        tipoVentaId: cUserStates.deshabilitado,
        nombre: "Deshabilitado"
    }
];

export const cUserRoles = {
    Admin: 1,
    Vendedor: 2,
    Soporte: 3,
}